import type { Game } from "../../api/campaigns";
import { WheelGamePreview } from "./previews/WheelGamePreview";
import { ScratchGamePreview } from "./previews/ScratchGamePreview";

/**
 * Pluggable per-game preview for the Games catalog. Add new games by key here.
 */
export function GameCatalogPreview({ game }: { game: Game }) {
  switch (game.key) {
    case "wheel_of_fortune":
      return <WheelGamePreview />;
    case "scratch_card":
      return <ScratchGamePreview />;
    default:
      return null;
  }
}
